// This hook manages the user's cases list
import { useState, useEffect } from 'react';
import { watchMyCases } from '../lib/watchMyCases';
import { db } from '../firebase';
import { useAuthState } from '../auth/AuthProvider';
import { logError } from '../lib/log';

export const useCases = (includeArchived = false) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuthState();

  useEffect(() => {
    if (!user?.uid) {
      setLoading(false);
      setData([]);
      return;
    }

    setLoading(true);
    const unsubscribe = watchMyCases(
      db,
      user.uid,
      includeArchived,
      (cases) => {
        setData(cases);
        setLoading(false);
        setError(null);
      },
      (err) => {
        logError('cases:watchMyCases', err);
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [user?.uid, includeArchived]);

  return { data, loading, error };
};
